import { computePamiScores } from "@repo/utils";
import { TRAIT_NAME_TO_PREFIX } from "@repo/pami";
import type { PamiDonnees, TraitResult } from "./pami.types";

export function computeScores(donnees: PamiDonnees): Record<string, number> {
  if (!donnees?.reponses || Object.keys(donnees.reponses).length === 0) {
    return {};
  }
  return computePamiScores(donnees.reponses);
}

export function extractScoresFromResult(result: TraitResult[]): Record<string, number> {
  const scores: Record<string, number> = {};
  result.forEach(({ trait, value }) => {
    const prefix = TRAIT_NAME_TO_PREFIX[trait];
    if (prefix) scores[prefix] = Math.min(10, Math.round(value));
  });
  return scores;
}

// Les paliers vivent dans `@repo/pami` : le rapport PDF, construit côté Convex,
// doit lire un score exactement comme cette page l'affiche.
export {
  couleurNiveau as getScoreColor,
  niveauScore as getScoreLabel,
} from "@repo/pami";
